import React from "react";
import get from "lodash/get";
import ClubProfilePage from "../../club/ClubProfilePage";

export function ClubPage(props) {
    const data = get(props, ["data"], {});
    const { club, adId, hostname, isMember } = data;

    if (!club) {
        return (
            <div style={{ textAlign: "center", padding: "60px 20px" }}>
                <h2>Club Not Found</h2>
            </div>
        );
    }

    return (
        <div className="custom-page-root">
            <ClubProfilePage club={club} adId={adId} hostname={hostname} initialIsMember={isMember} />
        </div>
    );
}

export default ClubPage;
